import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { FormContainer, PasswordUpdated } from './components';
import {
  ActivateAccount,
  CreateNewPassword,
  ForgotPassword,
  PasswordRecovery,
  Signin,
  Signup
} from './forms';
import { APP_KEYS } from '../common/consts';

export const AuthPageContainer = () => (
  <FormContainer>
    <Routes>
      <Route element={<Signup />} path={APP_KEYS.ROUTER_KEYS.SIGNUP} />
      <Route element={<Signin />} path={APP_KEYS.ROUTER_KEYS.SIGNIN} />
      <Route
        element={<ActivateAccount />}
        path={APP_KEYS.ROUTER_KEYS.ACTIVATE_ACCOUNT}
      />
      <Route
        element={<PasswordRecovery />}
        path={APP_KEYS.ROUTER_KEYS.PASSWORD_RECOVERY}
      />
      <Route
        element={<ForgotPassword />}
        path={APP_KEYS.ROUTER_KEYS.FORGOT_PASSWORD}
      />
      <Route
        element={<PasswordUpdated />}
        path={APP_KEYS.ROUTER_KEYS.PASSWORD_UPDATED}
      />
      <Route
        element={<CreateNewPassword />}
        path={`${APP_KEYS.ROUTER_KEYS.CREATE_NEW_PASSWORD}/:token`}
      />

      <Route element={<Signin />} path="*" />
    </Routes>
  </FormContainer>
);
